let ticking = false;
let navBarElement = null;
let productsContainer = null;

function initNavbar() {

    navBarElement = document.getElementById('navbar');

    productsContainer = navBarElement.querySelector('.products');
    navBarElement.querySelector('.products-link').onclick = handleProductClick
    navBarElement.querySelectorAll('.languages-container .dropdown-item').forEach(language => {
        language.onclick = handleLanguageSelect;
    })

    document.addEventListener('scroll', onScroll)

    setTimeout(setupCategoriesOverflow, 512);

    onScroll();
}

function setupCategoriesOverflow() {
    const columnsContainer = navBarElement.querySelector('.nav-columns-container');


    const targetHeight = columnsContainer.offsetHeight - 10;
    columnsContainer.style.height = `${targetHeight + 10}px`; // Fix container height in place


    const initialColumn = columnsContainer.querySelector('.nav');
    const secondColumn = columnsContainer.querySelector('.nav.d-none');

    let accumulatedHeight = 0;

    let overflowingChilds = [];

    for (const child of initialColumn.children) {
        accumulatedHeight += child.offsetHeight;
        if (child.nodeName === 'H2') {
            const nextElementHeight = child.nextElementSibling.offsetHeight;
            // If is a header, also add the the height of the
            // next element when checking if needs to be moved
            if (accumulatedHeight + nextElementHeight > targetHeight) {
                overflowingChilds.push(child);
            }
        } else {
            if (accumulatedHeight > targetHeight) {
                overflowingChilds.push(child);
            }
        }
    }

    // Remove lingering products
    let hasCategoryAbove = false;
    overflowingChilds = overflowingChilds.filter(child => {
        if (child.nodeName === 'H2') {
            hasCategoryAbove = true;
        }
        if (!hasCategoryAbove) {
            // Remove products from previous category
            initialColumn.removeChild(child);
            return false;
        }
        return true;
    })


    // Clean up second column
    accumulatedHeight = 0;
    overflowingChilds = overflowingChilds.filter(child => {
        accumulatedHeight += child.offsetHeight;
        if (child.nodeName === 'H2') {
            const nextElementHeight = child.nextElementSibling.offsetHeight;
            // If is a header, also add the the height of the
            // next element when checking if needs to be moved
            if (accumulatedHeight + nextElementHeight > targetHeight) {
                initialColumn.removeChild(child);
                return false;
            }
        } else {
            if (accumulatedHeight > targetHeight) {
                initialColumn.removeChild(child);
                return false;
            }
        }

        return true;
    })

    overflowingChilds.forEach(child => secondColumn.appendChild(child))

    if (secondColumn.children.length) {
        // There is content for a second column
        secondColumn.classList.remove('d-none');
        navBarElement.querySelector('.products').style.maxWidth = '940px';
        columnsContainer.style.minWidth = '360px';
    }

    // Also setup max width on each column to prevent resizing on hover
    initialColumn.style.maxWidth = `${initialColumn.offsetWidth}px`

    if (secondColumn.children.length) {
        // There is content for a second column
        secondColumn.style.maxWidth = `${secondColumn.offsetWidth}px`
    }
}

function onScroll() {
    if (!ticking) {
        window.requestAnimationFrame(function () {

            const scrollY = window.scrollY;
            if (scrollY > 200) {
                navBarElement.classList.add('opaque');
            } else {
                navBarElement.classList.remove('opaque');
            }

            ticking = false;
        });
        ticking = true;
    }
}

function handleProductClick(e) {
    if (window.innerWidth >= 768) {
        e.preventDefault();
        toggleProducts();
    }
}

function toggleProducts() {
    if (productsContainer.classList.contains('hidden')) {
        productsContainer.classList.remove('hidden');
        navBarElement.querySelector('.products-link').classList.add('active');
        setTimeout(() => {
            document.body.addEventListener('click', handleClickOutsideProducts)
        }, 0);
    } else {
        productsContainer.classList.add('hidden');
        navBarElement.querySelector('.products-link').classList.remove('active');
        document.body.removeEventListener('click', handleClickOutsideProducts);
    }
}

function handleClickOutsideProducts(e) {
    if (!productsContainer.contains(e.target)) {
        toggleProducts();
    }
}

function handleLanguageSelect(e) {
    e.preventDefault();
    document.cookie = `lang=${e.target.dataset.lang}`;
    window.location.reload();
}

export {
    initNavbar
};